import React from 'react';

import { FieldChangeTrigger } from '../../../enums/form';
import type { FieldChangeTriggerHandler } from '../../../types/form';

export const adaptField =
  (Component: any) =>
  // eslint-disable-next-line react/display-name
  ({ onChange, ...props }: any) => {
    const handleChange: FieldChangeTriggerHandler<string> = ({ value, trigger }) => {
      if (trigger === FieldChangeTrigger.Change) {
        onChange(value);
      }
    };

    return <Component onChange={handleChange} {...props} />;
  };

export const adaptFieldWithBlur =
  (Component: any) =>
  // eslint-disable-next-line react/display-name
  ({ onChange, ...props }: any) => {
    const handleChange: FieldChangeTriggerHandler<string> = ({ value, trigger }) => {
      if (trigger === FieldChangeTrigger.Change) {
        onChange(value);
      } else if (trigger === FieldChangeTrigger.Blur) {
        onChange(value);
      }
    };

    return <Component onChange={handleChange} {...props} />;
  };
